import classNames from "classnames";
import styles from "./ShadowBox.module.scss";

export const ShadowBox = ({ children, className }) => (
  <div className={classNames(styles.cardStep, className)}>{children}</div>
);
